"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendar = void 0;
var luxon_1 = require("luxon");
var feriado_patamar_json_1 = __importDefault(require("./data/feriado-patamar.json"));
var Calendar = /** @class */ (function () {
    function Calendar() {
    }
    /**
     * Retorna a data atual em UTC
     */
    Calendar.now = function () {
        return luxon_1.DateTime.utc();
    };
    Calendar.isWeekend = function (date) {
        return [6, 7].includes(date.weekday);
    };
    Calendar.isFeriado = function (date) {
        var _a;
        var anoFeriado = String(date.year);
        if (feriado_patamar_json_1.default !== undefined) {
            var datasFeriados = feriado_patamar_json_1.default;
            return (_a = datasFeriados === null || datasFeriados === void 0 ? void 0 : datasFeriados[anoFeriado]) === null || _a === void 0 ? void 0 : _a.some(function (item) { return item === date.toISODate(); });
        }
        return false;
    };
    Calendar.getNumericMonths = function () {
        return luxon_1.Info.months('numeric').map(function (month) { return parseInt(month, 10); });
    };
    Calendar.hoursInYear = function (ano) {
        return Calendar.getNumericMonths().reduce(function (accumulator, current) { return accumulator + Calendar.hoursInMonth(current, ano); }, 0);
    };
    // ! DST - Daylight Saving Time
    Calendar.hoursInMonth = function (mes, ano) {
        return luxon_1.DateTime.fromObject({ month: mes, year: ano }).daysInMonth * 24;
    };
    // ! DST - Daylight Saving Time
    Calendar.hoursInInterval = function (interval) {
        return interval.length('days') * 24;
    };
    Calendar.fromBrasiliaTimeToUTC = function (date) {
        return luxon_1.DateTime.fromObject(__assign(__assign({}, date.toObject()), { zone: Calendar.BRASILIA_TIMEZONE })).toUTC();
    };
    Calendar.toUTC = function (date) {
        return luxon_1.DateTime.fromObject(__assign(__assign({}, date.toObject()), { zone: date.zoneName })).toUTC();
    };
    Calendar.fromUTCToBrasiliaTime = function (date) {
        return luxon_1.DateTime.fromObject(__assign(__assign({}, date.toObject()), { zone: 'UTC' })).setZone(Calendar.BRASILIA_TIMEZONE);
    };
    /**
     * Retorna o sábado anterior às 00:00:00
     */
    Calendar.getInicioSemanaOperativa = function (day) {
        var date = day.startOf('day');
        var saturday = 6;
        while (date.weekday !== saturday) {
            date = date.minus({ days: 1 });
        }
        return date;
    };
    /**
     * Retornar a próxima sexta às 23:59:59
     */
    Calendar.getFimSemanaOperativa = function (day) {
        var date = day.endOf('day');
        var friday = 5;
        while (date.weekday !== friday) {
            date = date.plus({ days: 1 });
        }
        return date;
    };
    Calendar.getIntervaloSemanaOperativa = function (day) {
        return [Calendar.getInicioSemanaOperativa(day), Calendar.getFimSemanaOperativa(day)];
    };
    Calendar.getDiasSemanaOperativaMes = function (semana, mes, ano) {
        var semanaOperativa = Calendar.getSemanasOperativas(ano, mes)[semana - 1];
        var inicio = luxon_1.DateTime.fromJSDate(semanaOperativa.inicio);
        var fim = luxon_1.DateTime.fromJSDate(semanaOperativa.fim);
        var dias = [];
        while (inicio < fim) {
            if (inicio.month === mes) {
                dias.push(inicio.toJSDate());
            }
            inicio = inicio.plus({ days: 1 });
        }
        return dias;
    };
    Calendar.getSemanasOperativas = function (ano, mes) {
        var startOfMonth = luxon_1.DateTime.fromObject({
            year: ano,
            month: mes,
        }).startOf('month'); // * início daquele mês daquele ano
        var endOfMonth = luxon_1.DateTime.fromObject({
            year: ano,
            month: mes,
        }).endOf('month'); // * início daquele mês daquele ano
        var _a = Calendar.getIntervaloSemanaOperativa(startOfMonth), inicioSemana = _a[0], fimSemana = _a[1];
        var semanasOperativas = [];
        var semanaCorrente = 1;
        var inicio = inicioSemana;
        var fim = fimSemana;
        do {
            semanasOperativas.push({
                ano: ano,
                mes: mes,
                semana: semanaCorrente,
                inicio: inicio.toJSDate(),
                fim: fim.toJSDate(),
            });
            semanaCorrente += 1;
            inicio = inicio.plus({ days: 7 });
            fim = fim.plus({ days: 7 });
        } while (inicio <= endOfMonth);
        return semanasOperativas;
    };
    /**
     * Retorna checagem se uma data refere-se a um dia útil ou não.
     *
     * @param targetDate
     */
    Calendar.isDiaUtil = function (targetDate) {
        return !Calendar.isWeekend(targetDate) && !Calendar.isFeriado(targetDate);
    };
    /**
     * Retorna data do dia útil com base no mês e ano e quantidade de dias
     *
     * @param year Ano de referência
     * @param month Mês de referência
     * @param days Quantidade de dias
     */
    Calendar.diaUtil = function (year, month, days) {
        // Começamos a "contagem" do último dia do mês anterior, pois se o du que estamos buscando for
        // 1 du, precisamos que seja retornado o primeiro dia útil do mês em questão
        // (considerando os casos em que o primeiro dia do mês caia em um final de semana)
        var targetDate = luxon_1.DateTime.fromObject({
            year: year,
            month: month,
        })
            .minus({ day: 1 })
            .startOf('day');
        var workDays = days;
        do {
            targetDate = targetDate.plus({ days: 1 });
            if (this.isDiaUtil(targetDate)) {
                workDays -= 1;
            }
        } while (workDays >= 1);
        return targetDate;
    };
    /**
     * Retorna lista de dias úteis com base no mês e ano
     *
     * @param year Ano de referência
     * @param month Mês de referência
     */
    Calendar.diasUteis = function (year, month) {
        var targetDate = luxon_1.DateTime.fromObject({
            year: year,
            month: month,
        }).startOf('month');
        var diasUteis = [];
        do {
            if (this.isDiaUtil(targetDate)) {
                diasUteis.push(targetDate);
            }
            targetDate = targetDate.plus({ days: 1 });
        } while (targetDate.month === month);
        return diasUteis;
    };
    /**
     * Retorna o próximo dia util com base na data enviada.
     *
     * @param currentDate
     */
    Calendar.getNextDiaUtil = function (currentDate) {
        var nextDiaUtil = currentDate.plus({ day: 1 });
        while (!this.isDiaUtil(nextDiaUtil)) {
            nextDiaUtil = nextDiaUtil.plus({ day: 1 });
        }
        return nextDiaUtil;
    };
    /**
     * DateTime arredondamento
     * 14:30:00 = 14:00:00
     * 14:30:01 = 15:00:00
     */
    Calendar.getDateTimeRounded = function (dateTime) {
        if (dateTime === void 0) { dateTime = luxon_1.DateTime.local(); }
        var newDateTime = dateTime.set({ millisecond: 0 });
        if (newDateTime.minute > 30 || (newDateTime.minute === 30 && newDateTime.second > 0)) {
            newDateTime = newDateTime.plus({ hour: 1 });
        }
        newDateTime = newDateTime.set({ minute: 0, second: 0 });
        return newDateTime;
    };
    /**
     * Retorna a data atingida de dia atual com a quantidade de dias úteis buscadas
     *
     * @param days Quantidade de dias úteis para buscar.
     */
    Calendar.dateAfterDiasUteis = function (days, currentDate) {
        if (currentDate === void 0) { currentDate = Calendar.now(); }
        var date = currentDate;
        var diasUteisContabilizados = 0;
        while (diasUteisContabilizados < days) {
            date = date.plus({ day: 1 });
            if (this.isDiaUtil(date)) {
                diasUteisContabilizados += 1;
            }
        }
        return date;
    };
    /**
     * Retorna a quantidade de dias úteis até atingir determinada data
     *
     * @param days Quantidade de dias úteis para buscar.
     */
    Calendar.diasUteisUntilDate = function (date) {
        var diasUteisContabilizados = 0;
        var currentDate = Calendar.now();
        while (currentDate.toSQLDate() < date.toSQLDate()) {
            currentDate = currentDate.plus({ day: 1 });
            if (this.isDiaUtil(currentDate)) {
                diasUteisContabilizados += 1;
            }
        }
        return diasUteisContabilizados;
    };
    /**
     * Retorna a formatação de data para Mes Ano(Ex.: Nov 2021)
     *
     * @param date Data a ser transformada.
     */
    Calendar.transformDateToMonthYear = function (date) {
        return luxon_1.DateTime.fromISO(date)
            .toUTC()
            .toFormat('MMM yy')
            .replace('.', '')
            .split('')
            .map(function (letter, index) { return (index === 0 ? letter.toUpperCase() : letter); })
            .join('');
    };
    /* Retorna um texto formatado em anos e meses de um periodo
     *
     * @param dataInicio Inicio do periodo
     * @param dataInicio Final do periodo
     *
     */
    Calendar.getPeriodoFormatYearsAndMonths = function (dataInicio, dataFim) {
        if (dataInicio >= dataFim) {
            return '';
        }
        var intervalo = Math.floor(luxon_1.Interval.fromDateTimes(dataInicio, dataFim).length('months'));
        var quantidadeAnos = Math.trunc(intervalo / 12);
        var quantidadeMeses = Math.floor(intervalo % 12);
        var textoPeriodoFormatado = '';
        if (quantidadeAnos > 0) {
            textoPeriodoFormatado = quantidadeAnos + " ano" + (quantidadeAnos === 1 ? '' : 's') + (quantidadeMeses > 0 ? ' e' : '');
        }
        if (quantidadeMeses > 0) {
            textoPeriodoFormatado = textoPeriodoFormatado + " " + quantidadeMeses + " " + (quantidadeMeses === 1 ? 'mês' : 'meses');
        }
        return textoPeriodoFormatado;
    };
    /* Retorna um data 2 meses atrás no início do mês
     */
    Calendar.getDateInitMonthTwoMonthsAgo = function () {
        return luxon_1.DateTime.utc()
            .minus({ months: 2 })
            .startOf('month');
    };
    Calendar.splitPeriodoAnualmente = function (periodo) {
        var _a;
        /**
         * By design Interval é fechado no início e aberto no fim. Por isso estou diminuindo um 1s
         * do fim para pegar os casos em que fim 01/01/yyyy 00:00:00.
         */
        var ultimoAno = periodo.end.minus(luxon_1.Duration.fromObject({ seconds: 1 })).year;
        var primeiroAno = periodo.start.year;
        var periodoRestante = periodo;
        var periodoDoAno;
        var periodosAnuais = [];
        var ano = primeiroAno + 1;
        do {
            _a = periodoRestante.splitAt(luxon_1.DateTime.fromObject({ year: ano })), periodoDoAno = _a[0], periodoRestante = _a[1];
            periodosAnuais.push(periodoDoAno);
            ano += 1;
        } while (periodoRestante && ano <= ultimoAno);
        if (periodoRestante) {
            periodosAnuais.push(periodoRestante);
        }
        return periodosAnuais;
    };
    Calendar.BRASILIA_TIMEZONE = 'UTC-3';
    return Calendar;
}());
exports.Calendar = Calendar;
